import { BACKGROUND_IMAGE_DESKTOP, BACKGROUND_IMAGE_MOBILE } from '../elements/assets'
import { BUTTON, BUTTON_SETTINGS } from '../elements/link'

export const HERO_SECTION_V4 = `
...on heroSectionV4_Entry {
  id
  typeHandle

  backgroundColor
  subheading

  heading {
    html
  }
  description

  ${ BUTTON }
  ${ BUTTON_SETTINGS }

  ${ BACKGROUND_IMAGE_DESKTOP }
  ${ BACKGROUND_IMAGE_MOBILE }
}
`
